import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {FormControl, Validators} from "@angular/forms";

export interface IssueInsurancePolicyChronieData {
  text: string;
  body: string;
}

@Component({
  selector: 'app-issue-insurance-policy-chronie-dialog',
  templateUrl: './issue-insurance-policy-chronie-dialog.component.html',
  styleUrls: ['./issue-insurance-policy-chronie-dialog.component.scss']
})
export class IssueInsurancePolicyChronieDialogComponent {
  text = '';
  body = '';
  periodStartControl: FormControl = new FormControl(null, Validators.required);
  minDate: string;
  constructor(
    public dialogRef: MatDialogRef<IssueInsurancePolicyChronieDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IssueInsurancePolicyChronieData

  ) {
    this.text = data.text;
    this.body = data.body;
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    const yyyy = tomorrow.getFullYear();
    const mm = String(tomorrow.getMonth() + 1).padStart(2, '0');
    const dd = String(tomorrow.getDate()).padStart(2, '0');
    this.minDate = `${yyyy}-${mm}-${dd}`;
  }
  confirm(): void {
    if (this.periodStartControl.invalid) {
      this.periodStartControl.markAsTouched();
      return;
    }
    const value = this.formatDate(this.periodStartControl.value);
    this.dialogRef.close({ success: true, data: value });
  }

  decline(): void {
    this.dialogRef.close({ success: false, data: null});
  }

  private formatDate(v: any): string {
    // Obsługa Date, string, moment (gdyby był)
    if (!v) { return null; }
    if (typeof v === 'string') {
      // Zakładamy, że już w formacie YYYY-MM-DD
      return v.substring(0, 10);
    }
    if (v instanceof Date) {
      const yyyy = v.getFullYear();
      const mm = String(v.getMonth() + 1).padStart(2, '0');
      const dd = String(v.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    }
    if (typeof v.format === 'function') {
      return v.format('YYYY-MM-DD');
    }
    return String(v);
  }


}
